module.exports = __webpack_public_path__ + "img/kefu2.aa64fee9.jpg";